

<div class="row p-2 " style="display: flex;justify-content: space-between;">
  <div *ngIf="showName" class="mat-body-1 displayFlex" [ngClass]="{'col-md-7':!IsConsentScreen,'col-md-8':IsConsentScreen}">
      <span *ngIf="!IsConsentScreen" [innerHTML]="question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span *ngIf="IsConsentScreen" [innerHTML]="question.consentQuestionLabel || question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span style="margin-left: 8px;" *ngIf="question.questionToolTip">
      <img class="dupIcon-padd iconzoom cursor"
           matTooltip="{{question.questionToolTip}}"
           src="/assets/icons/information_tooltip.svg"
           alt="info icon"
           matTooltipClass="my-custom-tooltip"
           matTooltipPosition="above"/>
      </span>
  </div>
  <div class="col-md-4 mat-body-1" [ngClass]="{'padd pl-4': showName}">
    <div *ngIf="question.options.length > 0"  [ngClass]="{'ml-4': !showName}">
      <select 
      [disabled]="IsReadOnly" class="dropdown-style cursor" 
      [ngClass]="{'w-60': showName,'dropdownWidth': !showName}"
      (change)="onDropdownClick($event, $event.target.value)">
        <option>Select</option>
        <option *ngFor="let opt of question.options" 
        [selected]="opt.value == question.responseText"
        [hidden]="opt.isQuesOptionVisible==false">
        {{opt.value}}
        </option>
      </select>
    </div>  
  </div>
</div>
<div class="row" *ngIf="errormgvisible" [ngClass]="{'offset-8': showName,'offset-1 m-0 p-0 mt-2 pl-2': !showName}">
  <div class=" mat-body-1 errormsg margin-top pl-2 pt-2" *ngFor="let error of validationerrormessage">{{error}}</div>
</div>



